import React, { useContext } from "react";
import { ActionContext } from "views/logic/ActionContext";
import fieldTypeFor from "views/logic/fieldtypes/FieldTypeFor";
import ActionDropdown from "views/components/actions/ActionDropdown";
import TypeSpecificValue from "views/components/TypeSpecificValue";
import useOverflowingComponents from "views/hooks/useOverflowingComponents";
import { Menu } from "components/bootstrap";
import Popover from "components/common/Popover";
import hasMultipleValueForActions from "views/components/visualizations/utils/hasMultipleValueForActions";
import { humanSeparator } from "views/Constants";
import PopoverTitle from "views/components/visualizations/OnClickPopover/PopoverTitle";
import useFieldActions from "views/components/actions/useFieldActions";
const ValueActionsDropdown = ({ value, field, onActionRun, setStep }) => {
  const actionContext = useContext(ActionContext);
  const { additionalHandlerArgs } = useFieldActions();
  const { overflowingComponents, setOverflowingComponents } = useOverflowingComponents();
  const type = fieldTypeFor(field, actionContext.fieldTypes);
  const handlerArgs = {
    field,
    type,
    value,
    contexts: actionContext,
    ...additionalHandlerArgs
  };
  const showMultipleValueHeader = hasMultipleValueForActions(actionContext);
  const onBackToValueSelect = () => setStep("values");
  return /* @__PURE__ */ React.createElement(
    Popover.Dropdown,
    {
      title: /* @__PURE__ */ React.createElement(PopoverTitle, { onBackClick: onBackToValueSelect }, showMultipleValueHeader ? actionContext == null ? void 0 : actionContext.valuePath.map((o) => Object.values(o)[0]).join(humanSeparator) : /* @__PURE__ */ React.createElement(React.Fragment, null, field, " = ", /* @__PURE__ */ React.createElement(TypeSpecificValue, { field, value, type: handlerArgs == null ? void 0 : handlerArgs.type, truncate: true })))
    },
    /* @__PURE__ */ React.createElement(Menu, { opened: true }, /* @__PURE__ */ React.createElement(
      ActionDropdown,
      {
        handlerArgs,
        type: "value",
        onMenuToggle: onActionRun,
        overflowingComponents,
        setOverflowingComponents
      }
    ))
  );
};
export default ValueActionsDropdown;
